import { customAlphabet } from "nanoid";

export const text = customAlphabet("2346789ABCDEFGHJKLMNPQRTUVWXYZabcdefghijkmnpqrtwxyz", 32);
export const APIKeyPrefix = "gsk-";
export const apiKeyGenerator = () => APIKeyPrefix + text();
